import React, { Component } from 'react';
import type { DefaultTheme } from 'styled-components';
import { withTheme } from 'styled-components';
import { noop } from 'lodash-es';

import { TOOL_BUTTON_NAMES } from 'constants/user-account';
import { FjSideDrawer } from 'components/primitives';
import UserDrawer from './user-drawer';

import LicenseDrawer from './license-drawer';
import FJUDrawer from './fju-drawer';

interface UserAccountDrawerProps {
  theme: DefaultTheme;
  open: boolean;
  activeTab: string;
  onCloseRequest: () => void;
}

interface DrawerStyle {
  primaryColor: string;
  backgroundColor: string;
  width: string;
}

class UserAccountDrawer extends Component<UserAccountDrawerProps> {
  static defaultProps = {
    open: false,
    activeTab: '',
    onCloseRequest: noop,
  };

  get drawerStyle(): DrawerStyle {
    return {
      primaryColor: this.props.theme.colors.selectableLightBg,
      backgroundColor: this.props.theme.colors.white,
      width: '600px',
    };
  }

  renderDrawerContent(): React.ReactNode {
    switch (this.props.activeTab) {
      case TOOL_BUTTON_NAMES.USER:
        return [<UserDrawer key={1} />];
      case TOOL_BUTTON_NAMES.LICENSE:
        return [<LicenseDrawer key={2} />];
      case TOOL_BUTTON_NAMES.FJU:
        return [<FJUDrawer key={3} />];
      case TOOL_BUTTON_NAMES.HELP:
        return null;
      default:
        return null;
    }
  }

  render(): React.ReactElement {
    return (
      <FjSideDrawer
        open={this.props.open}
        onCloseRequest={() => this.props.onCloseRequest()}
        style={this.drawerStyle}
      >
        {this.renderDrawerContent()}
      </FjSideDrawer>
    );
  }
}

export default withTheme(UserAccountDrawer);
